<template>
  <section
    :class="[
      sectionClass,
      {
        'section--full-height': isFullHeight,
        'section--height-100': isFullHeight && header === 'none'
      }
    ]"
  >
    <Container v-if="breadcrumbsText" class="breadcrumbs mt-4 text-body-small">
      <div
        class="cursor-pointer link d-inline-block black--text"
        @click="$emit('click-breadcrumbs')"
      >
        <v-icon size="24" class="rotate-90 black--text"> $dropSmall</v-icon>
        {{ breadcrumbsText }}
      </div>
    </Container>
    <Container :class="containerClass">
      <h2
        v-if="titleText"
        :class="description ? '' : `mb-6 mt-2 mb-md-${titleBottomMargin}`"
        class="text-center"
        v-html="addNbsp(titleText)"
      />
      <div v-if="description" class="text-center mb-6">{{ description }}</div>
      <slot />
    </Container>
  </section>
</template>

<script>
import Container from '@/components/Atoms/Container';
import { mapGetters } from 'vuex';

export default {
  name: 'Section',
  components: { Container },
  props: {
    containerClass: {
      type: String,
      required: false
    },
    titleText: {
      type: String,
      required: false
    },
    sectionClass: {
      type: String,
      default: 'py-8 py-md-14'
    },
    isFullHeight: {
      type: Boolean,
      default: false
    },
    titleBottomMargin: {
      type: Number,
      default: 12
    },
    breadcrumbsText: {
      type: String,
      default: null
    },
    description: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      header: 'general/header'
    })
  }
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
